import { CodeListItemProps } from './types';

export const itemPropsAreEqual = (prevProps: CodeListItemProps, nextProps: CodeListItemProps) => {
  return prevProps?.codeData === nextProps?.codeData &&
    prevProps?.previousCodeData === nextProps?.previousCodeData &&
    prevProps?.description === nextProps?.description &&
    prevProps?.longDescription === nextProps?.longDescription &&
    prevProps?.edited === nextProps?.edited &&
    prevProps?.displayLongDescription === nextProps?.displayLongDescription &&
    (prevProps?.descValidationMessages?.length ?? 0) === (nextProps?.descValidationMessages?.length ?? 0) &&
    (prevProps?.descValidationMessages || []).every(
      prevMessage => (nextProps?.descValidationMessages || []).some(nextMessage => prevMessage === nextMessage)
    ) &&
    (prevProps?.longDescValidationMessages?.length ?? 0) === (nextProps?.longDescValidationMessages?.length ?? 0) &&
    (prevProps?.longDescValidationMessages || []).every(
      prevMessage => (nextProps?.longDescValidationMessages || []).some(nextMessage => prevMessage === nextMessage)
    );
};
